import { useEffect, useState } from "react";
import { UniformType, JobLevelsType } from "../model/datatype";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import {
  GetUniformType,
  GetJoblevels,
  GetUniformBenefitIncorrect,
  UserBasicInfo,
  UniformBenefit,
} from "../services/ApiUniformSurvey";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { blob } from "node:stream/consumers";
import UniformImage from "../components/font-end/UniformSurvey/UniformImage";
import { useUserProfile } from '../contexts/UserProfileContext';

export const ConfirmModal = (props: any) => {
  const [uniformList, setUniformList] = useState([]);
  const [jobLevels, setJobLevels] = useState([]);
  const [uniformChangeType, setUniformChangeType] = useState([]);
  const [uniformTypeImages, setUniformTypeImages] = useState(
    props.uniformImage
  );
  const [uniformTypeText, setUniformTypeText] = useState("");
  const [uniformTypeTextDes, setUniformTypeTextDes] = useState("");
  //const [departmentCode, setDepartmentCode] = useState(null);


  interface dataType {
    uniFormType: any;
    jobLevel: any;
    originAmount: any;
    selectedAmount: any;
    policyset: any;
    departmentCode: any;
  }

  interface dataTypeCode {
    departmentCode: any;
    originAmount: any;
    selectedAmount: any;
    policyset: any;
  }

  const [slectUniformType, setSlectUniformType] = useState<dataType>({
    uniFormType: props.uniformType,
    jobLevel: "",
    originAmount: "",
    selectedAmount: "",
    policyset: "",
    departmentCode: "",
  });

  const [departmentCode, setDepartmentCode] = useState<dataTypeCode>({
    departmentCode: "",
    originAmount: "",
    selectedAmount: "",
    policyset: "",
  });

  const [showPolicy, setShowPolicy] = useState(false);
  const [slectUniformVal, setSlectUniformVal] = useState("");
  const [slectJobLevel, setSelectJobLevel] = useState();
  const [validdateData, setValidateData] = useState("");
  const [show, setShow] = useState("none");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [btnYes, setBtnYes] = useState("");
  const [btnNo, setBtnNo] = useState("");
  const [btnNoText, setBtnNoText] = useState("no");
  const [statusCheck, setStatusCheck] = useState(true);
  const [userInfo, setUserInfo] = useState([]);
  const [job, setJob] = useState("");
  const [jsGetJob, setJsGetJob] = useState("");
  const [eButtomStatus, setEButtomStatus] = useState("no");
  const [selectSet1, setSelectSet1] = useState(false);
  const [selectSet3, setSelectSet3] = useState(false);
  const [select, setSelect] = useState(3);
  const [plan, setPlan] = useState(false);
  //const [plan, setPlan] = useState(1);
  const [policy, setpolicy] = useState("no");
  //const set: number = plan;
  //console.log("propsConfirm=", props);

  // console.log("props?.benefit?.shirtQty=", props?.benefit?.shirtQty);

  const { profile } = useUserProfile();

  useEffect(() => {
    setBtnNo(t("uniform_survey.conform_your_uniform.btn_no"));
    setBtnYes(t("uniform_survey.conform_your_uniform.btn_yes"));
    setUniformTypeImages(props.uniformImage);
    setUniformTypeText(props.uniformType);
    //setSelect(props?.benefit?.shirtQty);

    if (props?.benefit?.shirtQty === 1) {
      setSelect(1);
    }

    if (profile?.email) {
      UserBasicInfo(profile.email)
        .then((res) => {
          setDepartmentCode({
            departmentCode: res.departmentCode,
            selectedAmount: select,
            originAmount: props?.benefit?.shirtQty,
            policyset: policy,
          });
          setUserInfo(res);
          setJob(res.jobLevel);
        })
        .catch((error: any) => {
          // Silent fail
        });
    }

    if (select === 3 && profile?.email) {
      try {
        UniformBenefit(select, profile.email).then((response) => {
          if (localStorage.getItem("Language") === "en") {
            setUniformTypeText(response.shirtDescriptionEn);
          } else {
            setUniformTypeText(response.shirtDescriptionTh);
          }
          setUniformTypeTextDes(response.shirtDescriptionEn);
          if (response?.choices?.length > 0) {
            setPlan(true);
          }
        });
      } catch (error) {}
    }

    if (plan) {
      setSelectSet3(true);
    }
    if (!uniformList || uniformList.length <= 0) {
      GetUniformType()
        .then((response) => {
          const getData: any = response;
          setUniformList(getData);
        })
        .catch((error: any) => {
          //console.log('error=', error);
        });
      //console.log("uniformList=", uniformList);
    }
    if (!jobLevels || jobLevels.length <= 0) {
      GetJoblevels()
        .then((response) => {
          const getData: any = response;
          setJobLevels(getData);
        })
        .catch((error: any) => {
          // console.log('error=', error);
        });
    }
  }, [
    eButtomStatus,
    t,
    select,
    selectSet1,
    selectSet3,
    props?.benefit?.shirtQty,
    uniformTypeTextDes,
    profile?.email
  ]);

  // console.log("departmentCodexxxxx=", departmentCode);
  // console.log("setPlan=>", plan);

  function ValidateForm(e: any) {
    let ValidateMsg = "";
    let jobLevelValidate = "";
    let UniformValidate = "";
    let selectTypeValidate = "";
    let text: any = "";
    let textUniform: any = "";
    const select: any = document.getElementById("jobLevel");
    const selectUniform: any = document.getElementById("uniFormType");
    //alert(select);
    if (select !== null) {
      text = select.options[select.selectedIndex].text;
      setJsGetJob(text);
    }

    if (selectUniform !== null) {
      textUniform = selectUniform.options[selectUniform.selectedIndex].text;
    }

    // console.log('slectUniformType.uniFormType=',slectUniformType.uniFormType.length);
    // console.log('slectJobLevel=',slectJobLevel);
    // console.log('textUniform=',textUniform);

    if (!slectUniformType.uniFormType || slectUniformType.uniFormType.length === 0) {
      UniformValidate = "empty Level uniFormType";
    } else {
      UniformValidate = "";
    }

    if (textUniform === "--- Uniform Type ---") {
      jobLevelValidate = "empty Level uniFormType";
    } else {
      jobLevelValidate = "";
    }

    if (!checkArray(slectUniformVal) && text === "--- Job Level ---") {
      jobLevelValidate = "empty Level uniFormType";
    } else {
      jobLevelValidate = "";
    }

    if (e !== "yes" && slectUniformVal === "") {
      selectTypeValidate = "empty selectType";
    } else {
      selectTypeValidate = "";
    }

    ValidateMsg = jobLevelValidate + selectTypeValidate + UniformValidate;
    return ValidateMsg;
  }

  const setVal = (e: any) => {
    setSelect(e.target.value);
    window.history.pushState(
      "object or string",
      "Title",
      `?setType=${e.target.value}`
    );

    // console.log("e.target.value=", e.target.value);
    if (e.target.value == 1) {
      setShowPolicy(true);
      setpolicy("accept");
    }
  };

  const ConfrimSet = (e: any) => {
    setPlan(false);
    //setSelect(1)
  };

  const ConfrimType = (e: any) => {
    // setStatusBtnYes(e)
    //console.log("ConfrimTyp=", e);
    // console.log("(slectUniformType.uniFormType=", slectUniformType.uniFormType);
    const valid: string = ValidateForm(e);
    setValidateData(valid);
    //console.log('setValidateData=',valid);
    //return false;
    if (e === "yes") {
      if (statusCheck) {
        //if (slectUniformType.uniFormType == "" && statusCheck) {
        //('yes');
        // const state1 = {
        //   departmentCode: departmentCode.departmentCode,
        //   selectedAmount: select,
        //   departmentCodeFull: departmentCode,
        // };

        // console.log("sendData=", state1);
        // return false;
        navigate(
          "/choose_uniform?departmentCode=" +
            departmentCode.departmentCode +
            "&originType=" +
            props.benefit.shirtQty +
            "&setType=" +
            select +
            "&policy=" +
            policy,
          {
            state: {
              GetUniformType: props.uniformType,
              uniFormType:  props.uniformType,
              departmentCode: departmentCode.departmentCode,
              selectedAmount: select,
              departmentCodeFull: departmentCode,
            },
          }
        );
      } else if (valid === "") {
        // alert('no');
        navigate(
          "/choose_uniform?departmentCode=" +
            departmentCode.departmentCode +
            "&originType=" +
            props.benefit.shirtQty +
            "&setType=" +
            select +
            "&policy=" +
            policy,
          { state: slectUniformType }
        );
      }
    }
  };

  const cancelType = (e: any) => {
    //console.log("eButtomStatusE=", e);
    //console.log("eButtomStatus=", eButtomStatus);
    setEButtomStatus(e);
    if (e === "no") {
      setBtnNo(t("uniform_survey.conform_your_uniform.btn_cancel"));
      setBtnYes(t("uniform_survey.conform_your_uniform.btn_confirm"));
      setBtnNoText("yes");
      setShow("block");
      setValidateData("");
      setStatusCheck(false);
    } else {
      setShow("none");
      setStatusCheck(true);
      setBtnNoText("no");
      setBtnNo(t("uniform_survey.conform_your_uniform.btn_no"));
      setBtnYes(t("uniform_survey.conform_your_uniform.btn_yes"));
    }
  };

  const setInputChangeType = (e: any) => {
    // console.log('checkArray(slectUniformVal)=',checkArray(slectUniformVal))
    const { name, value } = e.target;
    //console.log('slectUniformVal=>',slectUniformVal);

    if (profile?.email) {
      UserBasicInfo(profile.email)
        .then((response) => {
          setUserInfo(response);
          setSelectJobLevel(response.jobLevel);
          setSlectUniformType({
            uniFormType: value,
            jobLevel: response.jobLevel,
            originAmount: props.benefit.shirtQty,
            selectedAmount: select,
            policyset: policy,
            departmentCode: departmentCode.departmentCode,
          });
        })
        .catch((error: any) => {});
    }

    if (slectUniformVal !== "") {
      if (value === "TL Shirt") {
        setSlectUniformType((oldValues: any) => ({
          ...oldValues,
          [name]: value,
          jobLevel: "Junior Management",
          originAmount: props.benefit.shirtQty,
          selectedAmount: select,
          policyset: policy,
          departmentCode: departmentCode.departmentCode,
        }));
      } else if (value === "Staff Shirt") {
        setSlectUniformType((oldValues: any) => ({
          ...oldValues,
          [name]: value,
          jobLevel: "Staff",
          originAmount: props.benefit.shirtQty,
          selectedAmount: select,
          policyset: policy,
          departmentCode: departmentCode.departmentCode,
        }));
      } else {
        if (slectUniformVal !== "") {
          setSlectUniformType((oldValues: any) => ({
            ...oldValues,
            [name]: value,
            jobLevel: slectJobLevel,
            originAmount: props.benefit.shirtQty,
            selectedAmount: select,
            policyset: policy,
            departmentCode: departmentCode.departmentCode,
          }));
        }
      }
    }

   // console.log("value=", value);
    if (value === "") {
      // console.log(uniformChangeType)
      setUniformTypeText(props.uniformType);
      setUniformTypeImages(props.uniformImage);
    } else {
      // console.log(
      //   "e.target.selectedOptions[0].label=",
      //   e.target.selectedOptions[0].label
      // );
      setUniformTypeText(e.target.selectedOptions[0].label);
      setUniformTypeImages(value);

      GetUniformBenefitIncorrect({
        uniFormType: value,
        jobLevel: slectJobLevel,
      })
        .then((response) => {
          if (response && response.length > 0) {
            setUniformTypeImages(response.shirtType); 
           // setUniformTypeTextDes(response.shirtDescriptionEn);
            if (localStorage.getItem("Language") === "en") {
              setUniformTypeText(response.shirtDescriptionEn);
            } else {
              setUniformTypeText(response.shirtDescriptionTh);
            }
            const getData: any = response;
            setUniformChangeType(getData);
          }
          //console.log('UniformChangeType=', response);
        })
        .catch((error: any) => {
          // console.log('error=', error);
          //counter++;
        });
    }

    setSlectUniformVal(value);
  };
  const setInputChangeJobLevel = (e: any) => {
    const { name, value } = e.target;
    setSelectJobLevel(value);
    setSlectUniformType((oldValues: any) => ({
      ...oldValues,
      [name]: value,
      jobLevel: value,
      originAmount: props.benefit.shirtQty,
      selectedAmount: select,
      policyset: policy,
      departmentCode: departmentCode.departmentCode,
    }));
    //setSlectUniformType({ "uniFormType": props.uniformType, "jobLevel":value})
  };

  const checkArray = (value: any) => {
    const disableType = [
      "Maintenance",
      "Driver Shirt",
      "TL Shirt",
      "Staff Shirt",
      "GL Shirt",
    ];
    //  console.log(disableType.indexOf(value) > -1); //true
    return disableType.indexOf(value) > -1;
  };
  // const checkArrayDes = (value: any) => {
  //   const disableType = [
  //     "Driver Shirt",
  //     "HR Shirt", 
  //   ];
  //   console.log('valueccccc=',value); //true
  //   return disableType.indexOf(value) > -1;
  // };

  // console.log('slectJobLevel=>',slectJobLevel);
  // console.log('slectUniformVal=>',slectUniformVal);

  const showHideModal = () => {
    props.handleContinue();
    window.location.reload();
  };

  const CloseModalPolicy = () => {
    setShowPolicy(false);
    setpolicy("no");
    setSelect(3);
  };

  const AcceptModalPolicy = () => {
    window.history.pushState(
      "object or string",
      "Title",
      window.location.href + `&policy=` + policy
    );
    setShowPolicy(false);
    setPlan(false);
    setSelect(1);
  };

  //console.log("uniformTypeText=", uniformTypeText);
  return (
    <>
      <Modal
        show={showPolicy}
        onHide={showHideModal}
        backdrop="static"
        keyboard={true}
      >
        <Modal.Header>
          <Modal.Title>
            {localStorage.getItem("Language") === "en" ? (
              <>Annual uniform agreement</>
            ) : (
              <>เอกสารยินยอมการรับเครื่องแบบบริษัทฯ</>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "291px", fontSize: "18px" }}>
          {localStorage.getItem("Language") === "en" ? (
            <>
              Accept to receive 1 set of the Company's uniform per year (which
              consists of shirt 1, pants 1 and bar only for female employees 1).
            </>
          ) : (
            <>
              เอกสารยินยอมการรับเครื่องแบบบริษัทฯ จำนวน 1 ชุดต่อปี
              (ซึ่งประกอบด้วย เสื้อ 1 กางเกง 1 และเสื้อชั้นในเฉพาะพนักงานหญิง 1)
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="w-100 p-0 m-0" style={{ flexWrap: "nowrap" }}>
          <div
            className="w-50 p-2 m-0 policy-btn-no"
            onClick={CloseModalPolicy}
          >
            {t("uniform_survey.your_uniform.infoUniform.CloseModalPolicy")}
          </div>
          <div
            className="w-50 p-2 m-0 policy-btn-accept"
            onClick={AcceptModalPolicy}
          >
            {t("uniform_survey.your_uniform.infoUniform.AcceptModalPolicy")}
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        show={props.showModal}
        onHide={showHideModal}
        backdrop="static"
        keyboard={true}
        className="confirmModal uniformModel"
      >
        <Modal.Header closeButton>
          <Modal.Title className="uniform-title">
            {plan
              ? t("uniform_survey.conform_your_uniform_set.title")
              : t("uniform_survey.conform_your_uniform.title")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="uniform-survey-info mb-0 mt-0">
            <Container>
              <Row className="uniform-type-item" style={{ display: show }}>
                <Col>
                  <Form.Select
                    className={`m-2 mb-3 ${
                      validdateData !== "" && slectUniformVal === ""
                        ? "require"
                        : ""
                    }`}
                    name="uniFormType"
                    id="uniFormType"
                    onChange={(e: any) => setInputChangeType(e)}
                  >
                    <option value="">--- Uniform Type ---</option>
                    {uniformList && uniformList.length > 0 ? (
                      <>
                        {uniformList.map((item: UniformType, index: number) => (
                          <option value={item.name} key={index}>
                            {localStorage.getItem("Language") === "en"
                              ? item?.descriptionEn
                              : item?.descriptionTh}
                          </option>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                  </Form.Select>
                </Col>
              </Row>
              {!checkArray(slectUniformVal) ? (
                <Row
                  className="uniform-job-level-item"
                  style={{ display: show }}
                >
                  <Col>
                    <Form.Select
                      className={`m-2 ${
                        validdateData !== "" && jsGetJob === "--- Job Level ---"
                          ? "require"
                          : ""
                      }`}
                      name="jobLevel"
                      id="jobLevel"
                      onChange={(e: any) => setInputChangeJobLevel(e)}
                    >
                      <option value="">--- Job Level ---</option>
                      {jobLevels && jobLevels.length > 0 ? (
                        <>
                          {jobLevels.map(
                            (item: JobLevelsType, index: number) => (
                              <option value={item.name} key={`jb-${item.id}`}>
                                {item.name}
                              </option>
                            )
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </Form.Select>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
              <Row>
                <Col xs={4} md={4}>
                  {/* <UniformImage imagesName={uniformTypeImages} size="xl" /> {uniformTypeImages} */}
                  {uniformTypeImages !== " .jpg" && uniformTypeImages !== "" ? (
                    <>
                      <UniformImage imagesName={uniformTypeImages} size="xl" customSize=""  />{" "}
                      {/* เลือกเอง */}
                      {/* <img
                        src={uniformTypeImages}
                        alt="UniformSurvey"
                        className="m-2 mb-2 rounded border w-100 item-shadow"
                      /> */}
                    </>
                  ) : (
                    <>
                      <UniformImage imagesName={props.uniformImage} size="xl" customSize=""  />{" "}
                      {/* ตามแผนก */}
                      {/* <img
                        src={uniformTypeImages}
                      {/* <img
                        src={props.uniformImage}
                        alt="UniformSurvey"
                        className="m-2 mb-2 rounded border w-100 item-shadow"
                      /> */}
                    </>
                  )}
                </Col>
                <Col xs={8} md={8}>
                  <div className="title-tpye m-1 mt-3 mb-2">
                    {plan
                      ? t("uniform_survey.your_uniform.uniform_set")
                      : t("uniform_survey.your_uniform.uniform_type")}
                  </div>
                  {/* <div className="title-show-type m-1 mb-3">{(uniformTypeText === "")?props.uniformType:uniformTypeText}</div> */}

                  {!plan ? (
                    <div className="title-show-type m-1 mb-3">
                      {uniformTypeText === "" ? (
                        <>
                          {localStorage.getItem("Language") === "en"
                            ? props?.uniformTypeNameEn
                            : props?.uniformTypeNameTh}
                        </>
                      ) : (
                        <>
                         {uniformTypeText}

                          {props.uniformType == "Red Collar" &&
                          slectUniformType.uniFormType == "Grey Collar" ? (
                            <div className="mt-5 fs-6 text-danger">
                              <div
                                className="mt-4 text-danger"
                                style={{ fontSize: "12px" }}
                              >
                                <span style={{ fontWeight: "blod" }}>
                                  {t("uniform_survey.choose_uniform.remark")}
                                </span>
                                :{" "}
                                {t(
                                  "uniform_survey.choose_uniform.remarkCaseRed"
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="set1"
                          name="set"
                          value="1"
                          onChange={(e: any) => setVal(e)}
                          checked={select == 1}
                        />
                        <label className="form-check-label" htmlFor="set1">
                          {t("uniform_survey.your_uniform.infoUniform.set1")}{" "}
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="set2"
                          name="set"
                          value="3"
                          onChange={(e: any) => setVal(e)}
                          checked={select == 3}
                        />
                        <label className="form-check-label" htmlFor="set2">
                          {t("uniform_survey.your_uniform.infoUniform.set3")}{" "}
                        </label>
                      </div>
                    </>
                  )}
                </Col>
                {/* <Col xs={3} md={3}>
                      <div className="amount mt-3">{t('uniform_survey.your_uniform.amount')}</div>
                      <div className="number mt-2">{props.uniformAmount}</div>
                  </Col> */}
              </Row>
            </Container>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="text-center w-100">
            {!plan ? (
              <>
                <Button
                  className="btn-no mx-2"
                  onClick={() => cancelType(btnNoText)}
                >
                  {btnNo}
                </Button>
                <Button
                  className="btn-yes mx-2"
                  onClick={() => ConfrimType("yes")}
                >
                  {btnYes}
                </Button>
              </>
            ) : (
              <>
                <Button
                  className="btn-yes mx-2"
                  onClick={() => ConfrimSet("yes")}
                >
                  {t("btn_ok")}
                </Button>
              </>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
